<template>
  <div id="service-staff-setting" class="shadow-md rounded-item">
    <vx-card>
      <div class="setting-card-hidden">
        <div class="setting-card-scroll">
          <h4 class="text-2xl font-bold mb-6">Services & Staff Setting</h4>
          <div class="flex align-center">
            <vs-switch v-model="key_service" class="my-6" @click.stop="updateService"/>
            <span class="pl-5">Your customers will see all those services when they check-in</span>
          </div>
          <div class="flex align-center" v-if="key_service == false">
            <vs-switch v-model="key_show_service" class="my-6" @click.stop="updateShowService"/>
            <span class="pl-5">Web checkout will show services column</span>
          </div>
          <div class="flex align-center">
            <vs-switch v-model="key_staff" class="my-6" @click.stop="updateStaff"/>
            <span class="pl-5">Your customers will see all those staffs when they check-in</span>
          </div>
          <div class="flex align-center" v-if="key_staff == false">
            <vs-switch v-model="key_show_staff" class="my-6" @click.stop="updateShowStaff"/>
            <span class="pl-5">Web checkout will show staffs column</span>
          </div>
          <div class="flex align-center">
            <vs-switch v-model="key_printer" class="my-6" @click.stop="updatePrinter"/>
            <span class="pl-5">Printer features will be activated</span>
          </div>
          <div class="flex align-center">
            <vs-switch v-model="key_email" class="my-6" @click.stop="updateEmail"/>
            <span class="pl-5">Your customers will be required to enter their email when check-in</span>
          </div>
          <div class="flex align-center">
            <vs-switch v-model="key_birthday" class="my-6" @click.stop="updateBirthday"/>
            <span class="pl-5">Your customers will be required to enter their birthday when check-in</span>
          </div>
          <div class="flex align-center">
            <vs-switch v-model="key_notify" class="my-6" @click.stop="updateNotify"/>
            <span class="pl-5">You will be received notification about good/bad reviews everyday by sms</span>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: 'vs-service-staff-setting',
  data(){
    return {
      key_service: false,
      key_show_service: false,
      key_staff: true,
      key_show_staff: false,
      key_printer: true,
      key_email: true,
      key_birthday: true,
      key_notify: true,
      loaded_data_num: 0,
      isOpenLoading: false,
      action_type: ''
    }
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = "Get list";
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods:{
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' staff failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' data failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    updateService(){
      const obj = {
        key: 'config.services.active',
        value: !this.key_service ? 1 : 0
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = "Update";
      this.key_show_service = false;
      this.$store.dispatch("appSetting/UPDATE_GENERAL_CONFIG", obj).then(() => {
        this.closeLoading();
      })
    },
    updateShowService(){
      const obj = {
        key: 'config.services.active',
        value: !this.key_show_service ? 2 : 0
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = "Update";
      this.$store.dispatch("appSetting/UPDATE_GENERAL_CONFIG", obj).then(() => {
        this.closeLoading();
      })
    },
    updateStaff(){
      const obj = {
        key: 'config.staffs.active',
        value: !this.key_staff ? 1 : 0
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = "Update";
      this.key_show_staff = false;
      this.$store.dispatch("appSetting/UPDATE_GENERAL_CONFIG", obj).then(() => {
        this.closeLoading();
      })
    },
    updateShowStaff(){
        const obj = {
        key: 'config.staffs.active',
        value: !this.key_show_staff ? 2 : 0
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = "Update";
      this.$store.dispatch("appSetting/UPDATE_GENERAL_CONFIG", obj).then(() => {
        this.closeLoading();
      })
    },
    updatePrinter(){
      const obj = {
        key: 'config.checkin.printer.active',
        value: !this.key_printer ? 1 : 0
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = "Update";
      this.$store.dispatch("appSetting/UPDATE_GENERAL_CONFIG", obj).then(() => {
        this.closeLoading();
      })
    },
    updateEmail(){
      const obj = {
        key: 'config.checkin.ask_email.active',
        value: !this.key_email ? 1 : 0
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = "Update";
      this.$store.dispatch("appSetting/UPDATE_GENERAL_CONFIG", obj).then(() => {
        this.closeLoading();
      })
    },
    updateBirthday(){
      const obj = {
        key: 'config.checkin.ask_birthday.active',
        value: !this.key_birthday ? 1 : 0
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = "Update";
      this.$store.dispatch("appSetting/UPDATE_GENERAL_CONFIG", obj).then(() => {
        this.closeLoading();
      })
    },
    updateNotify(){
      const obj = {
        key: 'config.review.notification',
        value: !this.key_notify ? 1 : 0
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = "Update";
      this.$store.dispatch("appSetting/UPDATE_GENERAL_CONFIG", obj).then(() => {
        this.closeLoading();
      })
    },

  },
  computed:{
    generalConfig(){
      return this.$store.getters["appSetting/generalConfig"];
    }
  },
  created(){
    this.$store.dispatch("appSetting/GET_GENERAL_CONFIG").then(() => {
      let generalConfig = {};
      generalConfig = this.$store.getters["appSetting/generalConfig"];
      this.key_service = generalConfig["config.services.active"] == 1 ? true : false;
      this.key_show_service = generalConfig["config.services.active"] == 0 ? false : true;
      this.key_staff = generalConfig["config.staffs.active"] == 1 ? true : false;
      this.key_show_staff = generalConfig["config.staffs.active"] == 0 ? false : true;
      this.key_printer = generalConfig["config.checkin.printer.active"] ? true : false;
      this.key_email = generalConfig["config.checkin.ask_email.active"] ? true : false;
      this.key_birthday = generalConfig["config.checkin.ask_birthday.active"] ? true : false;
      this.key_notify = generalConfig["config.review.notification"] ? true : false;
      this.loaded_data_num++;
    })
  }
}
</script>